import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyActivity } from '../propertyEndpoints'
import type { PropertyActivityFilters } from '../../types/propertyTypes'

/**
 * Unified property activity feed (status + rental + valuation), paginated and
 * server-side filterable by `type`. Gated on `id`, so the container passes ''
 * when the Activity tab isn't active to short-circuit the fetch. Keeps the
 * previous page's data on filter/page change so the table doesn't flash empty.
 */
export function usePropertyActivityQuery(
  id: MaybeRefOrGetter<string>,
  filters: MaybeRefOrGetter<PropertyActivityFilters>,
) {
  return useQuery({
    queryKey: () => propertyKeys.activity(toValue(id), toValue(filters)),
    queryFn: () => getPropertyActivity(toValue(id), toValue(filters)),
    enabled: () => Boolean(toValue(id)),
    placeholderData: keepPreviousData,
  })
}
